<mat-expansion-panel class="info-panel" [expanded]="pannelloAperto()">
  <mat-expansion-panel-header class="panel-header">
    @if(!selectedStreet()) {
      <mat-panel-title class="panel-title">
        Traffico riscontrato
      </mat-panel-title>
    }
  </mat-expansion-panel-header>

  @if(selectedStreet()) {
    <button mat-icon-button class="close-btn" (click)="backToList()">
      <mat-icon>arrow_back</mat-icon>
      Indietro
    </button>
  }

  @if(!selectedStreet()) {
    <div class="panel-subtitle">
      Seleziona un avviso per visualizzarlo sulla mappa
    </div>

    @if(isLoading()) {
      <div class="loader-container">
        <div class="spinner"></div>
          <div>Caricamento dati...</div>
      </div>
    }
  }

  <div class="panel-content">
    @if(fetchDataCompleted() && !selectedStreet()) {
      <mat-tab-group [selectedIndex]="activeTabIndex()" (selectedIndexChange)="onTabChange($event)" dynamicHeight>
        <!-- Tab 1: Monitoraggio del traffico -->
        <mat-tab label="Monitoraggio del traffico">
          <div style="padding-top: 12px;">
            @if(visibleStreets.length > 0) {
              @for(street of visibleStreets; track $index) {
                <ng-container *ngTemplateOutlet="streetCard; context: { street: street }"></ng-container>
              }
            } @else {
              <div>
                Nessuna segnalazione di traffico intenso al momento.
              </div>
            }
          </div>
        </mat-tab>
        <!-- Tab 2: Analisi dei segmenti -->
        <mat-tab label="Analisi dei segmenti">
          <div style="padding-top: 12px;">
            @for(street of streets; track street.routeId) {
              <ng-container *ngTemplateOutlet="streetCard; context: { street: street }"></ng-container>
            }
          </div>
        </mat-tab>
      </mat-tab-group>
      <!-- Template card -->
      <ng-template #streetCard let-street="street">
        <mat-card
          [id]="street.uniqueId || street.routeId"
          class="street-card"
          role="button"
          tabindex="0"
          (click)="activeTabIndex() === 1 ? selectStreet(street, true) : zoomToStreet(street)"
          (keydown.enter)="activeTabIndex() === 1 ? selectStreet(street, true) : zoomToStreet(street)"
          (mouseenter)="mouseOverStreet(street)"
          (mouseleave)="mouseOutStreet(street)"
        >
          <div class="street-row">
            @if(activeTabIndex() === 0) {
              <div class="traffic-info">
                <span class="traffic-dot-a"
                  [class.intenso]="street.traffic === 'TRAFFIC_JAM' || street.traffic === 'TRAFFIC_JAM_HEAVY'"
                  [class.medio]="street.traffic === 'SLOW'"
                  [class.assente]="street.traffic === 'NORMAL'">
                </span>
                <span class="traffic-dot-b"
                  [class.intenso]="street.traffic === 'TRAFFIC_JAM' || street.traffic === 'TRAFFIC_JAM_HEAVY'"
                  [class.medio]="street.traffic === 'SLOW'"
                  [class.assente]="street.traffic === 'NORMAL'">
                </span>
              </div>
            }

            <div class="street-info">
              @if(activeTabIndex() === 0) {
                <div class="traffic-level">
                  Traffico {{ street.trafficDescription }}
                </div>
              }

              <div class="street-name">
                {{ street.displayName }}
              </div>

              @if(activeTabIndex() === 0) {
                <div class="street-metrics" *ngIf="street.traffic">
                  <div class="street-length">
                    Lunghezza coda: {{ street.trafficJamLengthText || 'Calcolo in corso...' }}
                  </div>
                  <div class="delay" *ngIf="street.additionalTimeInSeconds > 0">
                    (+{{ street.additionalTime }})
                  </div>
                </div>
              }
            </div>
          </div>
        </mat-card>
      </ng-template>
    }

    @if(fetchSelectedStreetDataCompleted() && selectedStreet()) {
      @let street = selectedStreet();

      <div class="detail-header">
        <div class="detail-title-group">
          <div class="detail-title">
            {{ street?.displayName}}
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="chart-controls">
          <div class="date-interval">
            <label for="inputPeriodo1" class="date-interval-label"> Inizio intervallo 1 </label>
            <input id="inputPeriodo1" class="date-interval-input"
              type="date"
              [(ngModel)]="period1Start"
            >
          </div>
          <div class="date-interval">
            <label for="inputPeriodo2" class="date-interval-label"> Inizio intervallo 2</label>
            <input id="inputPeriodo2" class="date-interval-input"
              type="date"
              [(ngModel)]="period2Start"
            >
          </div>
          <div class="date-interval">
            <label for="inputGiorni" class="date-interval-label"> Numero giorni </label>
            <input id="inputGiorni" class="date-interval-input"
              type="number"
              [(ngModel)]="intervalDays"
              min="1"
              max="31"
            >
          </div>
          <div class="date-interval-button-section">
            <button class="date-interval-button" (click)="loadComparisonData()"> Confronta </button>
          </div>
        </div>
        <!-- Renderizzazione del grafico -->
        <!-- Caso di errore: mostra messaggio se le date selezionate si sovrappongono -->
        <div *ngIf="dateOverlapError" class="error-message"> {{ dateOverlapError }} </div>
        <!-- Caso 1: dati presenti e pronti da mostrare -->
        <div *ngIf="!dateOverlapError && lineChartData && lineChartData.datasets && lineChartData.datasets.length > 0 && lineChartData.labels && lineChartData.labels.length > 0">
          <div style="display: block; width: 400px; height: 350px;">
            <canvas baseChart
              [data]="lineChartData"
              [options]="lineChartOptions"
              [type]="'line'"
              [plugins]="lineChartPlugins"
            >
            </canvas>
          </div>
        </div>
        <!-- Caso 2: chiamata all'API terminata, ma non ci sono dati per gli intervalli selezionati -->
        <div *ngIf="!dateOverlapError && lineChartData && lineChartData.datasets && lineChartData.datasets.length > 0 && (!lineChartData.labels || lineChartData.labels.length === 0)">
          Nessun dato disponibile per gli intervalli selezionati.
        </div>
        <!-- Caso 3: chiamata API in corso -->
        <div *ngIf="!dateOverlapError && (!lineChartData || !lineChartData.datasets || lineChartData.datasets.length === 0)">
          Caricamento grafico in corso...
        </div>
      </div>
    } @else {
      @if(selectedStreet()) {
        <div class="loader-container">
          <div class="spinner"></div>
            <div>Caricamento dati...</div>
        </div>
      }
    }
  </div>
</mat-expansion-panel>
